import _styled from "styled-components";

var _StyledTooltipIcon;

var _excluded = ["children", "label", "html", "maxWidth", "placement"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { borderRadius, color, opacity } from 'styled-system';
import styled, { css, keyframes } from 'styled-components';
import { shouldForwardProp } from '../../utils';
import { useOutsideClick } from '../../utils';
import { BodySmall } from '../Text/Text';
import { createPopper } from '@popperjs/core';
import { bodySmall } from '../Mixins/Mixins';
import Box from '../Box/Box';
import { TooltipIcon } from '../Icons/generated';
import { strictSpace } from '../../utils';
import Drawer from '../Drawer/Drawer';
import usePortalContainer from '../../utils/portal';
import ThemeProvider from '../../ThemeProvider';
import useTheme from '../../useTheme';
var minWidthToShowTooltip = '600px';

var isLargeScreen = function isLargeScreen() {
  return window && window.matchMedia ? window.matchMedia("(min-width:".concat(minWidthToShowTooltip, ")")).matches : true;
};

var animateOutDuration = 200;
var animateInDuration = 250;
var id = 0;

var createId = function createId() {
  var newId = id++;
  return "tooltip-".concat(newId);
};

var fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var fadeOut = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
var StyledTooltipIcon = styled(TooltipIcon).attrs({
  size: '16px',
  color: 'iconPlaceholder'
}).withConfig({
  displayName: "Tooltip__StyledTooltipIcon",
  componentId: "sc-zbj0xs-0"
})(["vertical-align:baseline;@media (pointer:coarse){min-width:1.2rem;min-height:1.2rem;}"]);
export var StyledTooltip = styled.div.withConfig({
  displayName: "Tooltip__StyledTooltip",
  componentId: "sc-zbj0xs-1"
})(["", ";background:", ";color:", ";border-radius:4px;padding:", ";box-shadow:", ";position:absolute;z-index:1000;max-width:", ";white-space:pre-line;animation:", ";"], bodySmall, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.bgElevated;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.textSecondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.xs;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.shadow16;
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return props.animatingOut ? css(["", " ", "ms forwards"], fadeOut, animateOutDuration) : css(["", " ", "ms forwards"], fadeIn, animateInDuration);
});
var boxShadowInset = '5px';
export var StyledTriggerButton = styled.button.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Tooltip__StyledTriggerButton",
  componentId: "sc-zbj0xs-2"
})(["padding:0;background:transparent;line-height:", ";appearance:none;position:relative;display:inline-block;", ";transition:opacity 0.2s;&:after{position:absolute;content:'';background-color:currentColor;top:", ";left:", ";right:", ";bottom:", ";opacity:0;transition:opacity 0.2s;", "}&:hover{opacity:1;}&:focus,:active{opacity:1;:after{opacity:0.15;}}", ";", ";", ""], function (props) {
  return props.hasChildren ? 'auto' : '0';
}, opacity, boxShadowInset, boxShadowInset, boxShadowInset, boxShadowInset, borderRadius, borderRadius, strictSpace, color);
var focusInputType = 'focus';
var mouseInputType = 'mouse';

function Tooltip(_ref5) {
  var children = _ref5.children,
      label = _ref5.label,
      html = _ref5.html,
      maxWidth = _ref5.maxWidth,
      placement = _ref5.placement,
      rest = _objectWithoutProperties(_ref5, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipIsVisible = _useState2[0],
      setTooltipIsVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      drawerIsVisible = _useState4[0],
      setDrawerIsVisible = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      animatingOut = _useState6[0],
      setIsAnimatingOut = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openedByClick = _useState8[0],
      setOpenedByClick = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      uniqueId = _useState10[0],
      setUniqueId = _useState10[1];

  var buttonRef = useRef(null);
  var container = usePortalContainer();

  var _useTheme = useTheme(),
      themeKey = _useTheme.themeKey;

  var handleClickOutside = function handleClickOutside(e) {
    if (buttonRef.current && buttonRef.current.contains(e.target)) return;
    setOpenedByClick(false);
    handleCloseTooltip();
  };

  var tooltipRef = useOutsideClick(handleClickOutside);
  var tooltipText = typeof label !== 'string' ? label : html ? /*#__PURE__*/React.createElement(BodySmall, {
    dangerouslySetInnerHTML: {
      __html: label
    }
  }) : /*#__PURE__*/React.createElement(BodySmall, null, label);

  var handleCloseTooltip = function handleCloseTooltip() {
    setIsAnimatingOut(true);
    setTimeout(function () {
      setTooltipIsVisible(false);
      setIsAnimatingOut(false);
    }, animateOutDuration);
  };

  var hideTooltip = function hideTooltip(inputType) {
    return function () {
      if (inputType !== tooltipIsVisible) return;

      if (!openedByClick) {
        handleCloseTooltip();
      }
    };
  };

  var showTooltip = function showTooltip(inputType) {
    return function () {
      if (tooltipIsVisible === focusInputType || tooltipIsVisible === inputType) return;

      if (isLargeScreen()) {
        setTooltipIsVisible(inputType);
      } else {
        setDrawerIsVisible(true);
      }
    };
  };

  useEffect(function () {
    setUniqueId(createId());
  }, []);
  useEffect(function () {
    if (tooltipIsVisible) {
      var popperInstance = createPopper(buttonRef.current, tooltipRef.current, {
        placement: placement,
        modifiers: [{
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }]
      }); // fix for safari bug: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus

      var touchListener = function touchListener(event) {
        var isInsideTooltipButton = Boolean(event.target.closest('[data-tooltip-button]'));

        if (!isInsideTooltipButton) {
          setTooltipIsVisible(false);
          buttonRef.current.blur();
        }
      };

      window.document.addEventListener('touchstart', touchListener, false);
      return function () {
        popperInstance.destroy();
        window.document.removeEventListener('touchstart', touchListener, false);
      };
    }
  }, [placement, tooltipIsVisible]);
  var ariaProps = {
    'aria-label': 'more information'
  };

  if (tooltipIsVisible) {
    ariaProps['aria-describedby'] = uniqueId;
  }

  var handleOnClick = function handleOnClick() {
    setOpenedByClick(true);
    setTooltipIsVisible(true);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeKey
  }, drawerIsVisible ? /*#__PURE__*/React.createElement(Drawer, {
    removeDrawer: function removeDrawer() {
      return setDrawerIsVisible(false);
    },
    p: "m"
  }, /*#__PURE__*/React.createElement(_StyledBox, {
    minHeight: "4rem",
    pt: "xs",
    maxHeight: "70vh",
    overflow: "auto"
  }, tooltipText)) : Boolean(tooltipIsVisible) ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(StyledTooltip, {
    role: "tooltip",
    animatingOut: animatingOut,
    id: uniqueId,
    ref: tooltipRef,
    maxWidth: maxWidth
  }, tooltipText), container) : null), /*#__PURE__*/React.createElement(StyledTriggerButton, _extends({
    onClick: handleOnClick,
    "data-testid": "trigger-button",
    ref: buttonRef,
    onFocus: showTooltip(focusInputType),
    onBlur: hideTooltip(focusInputType),
    onMouseEnter: showTooltip(mouseInputType),
    onMouseMove: showTooltip(mouseInputType),
    onMouseLeave: hideTooltip(mouseInputType),
    "data-tooltip-button": true,
    hasChildren: Boolean(children)
  }, ariaProps, rest), children || _StyledTooltipIcon || (_StyledTooltipIcon = /*#__PURE__*/React.createElement(StyledTooltipIcon, null))));
}

Tooltip.defaultProps = {
  borderRadius: '100px',
  maxWidth: '22rem',
  p: 'xxs',
  opacity: '1',
  placement: 'top-start'
};
Tooltip.propTypes = {
  /** UI to display in the tooltip popup. Pass a string or JSX. */
  label: PropTypes.node.isRequired,

  /** If provided, will replace the default (i) information icon. */
  children: PropTypes.node,

  /** Override the default shape of the focus outline by changing tooltip button shape */
  borderRadius: PropTypes.string,

  /** Instead of inheriting color, you can also specify one */
  color: PropTypes.string,

  /** Update max width of the tooltip overlay */
  maxWidth: PropTypes.string,

  /** Default opacity of non-hovered tooltip is .8 */
  opacity: PropTypes.string,

  /** adjust tooltip position, see https://popper.js.org/ for details */
  placement: PropTypes.string
};
export default Tooltip;

var _StyledBox = styled(Box).withConfig({
  displayName: "Tooltip___StyledBox",
  componentId: "sc-zbj0xs-3"
})(["text-align:left;"]);